import React from "react";
import { getCapitalTypeLabel } from "../../constants/capitalTypes";
import styles from "./CapitalTable.module.css";

const CapitalTable = ({ items, loading, onEdit, onDelete }) => {
  if (loading) return <div className={styles.state}>جارِ التحميل...</div>;
  if (!items.length) return <div className={styles.state}>لا توجد بيانات لعرضها</div>;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>النوع</th>
            <th>العنوان</th>
            <th>المبلغ</th>
            <th>التاريخ</th>
            <th>ملاحظات</th>
            <th>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td>
                <span className={item.type === 1 ? styles.cashBadge : styles.assetBadge}>
                  {item.typeName || getCapitalTypeLabel(item.type)}
                </span>
              </td>
              <td>{item.title}</td>
              <td>{Number(item.amount).toLocaleString("ar-EG")} ج.م</td>
              <td>{new Date(item.date).toLocaleDateString("ar-EG")}</td>
              <td className={styles.notes}>{item.notes || "-"}</td>
              <td>
                <div className={styles.rowActions}>
                  <button className={styles.editBtn} onClick={() => onEdit(item)}>تعديل</button>
                  <button className={styles.deleteBtn} onClick={() => onDelete(item)}>حذف</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CapitalTable;